import React, { useState, useEffect } from 'react'

import {
  TableContainerStyled,
  TableStyled,
  TableFooter,
  TableCellStyled,
  TableRowStyled,
  TableBodyStyled,
  TableHeadStyled
} from 'components'
import { ILockDataItems, DjurServices } from 'services/NGT/DjurServices'
import { COLORS, FORMAT } from 'utils'
import { useLoading } from 'hooks'
import { useDjurService } from '../../../../../../context'
import { useFormContext, UseFormReturn } from 'react-hook-form'

const TableDataLock: React.FC = () => {
  const { setLoading } = useLoading()
  const { state } = useDjurService()

  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [pageCount, setPageCount] = useState<number>(0)
  const [paginatedTable, setPaginatedTable] = useState<ILockDataItems[]>([])
  const [total, setTotal] = useState<number>(0)

  const form: UseFormReturn<any, object> & { errors?: any } = useFormContext()

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(1)
  }

  const getTableDataWithPagination = () => {
    setLoading('loading')

    DjurServices()
      .getInfoAtendimentoDjur({
        flDadosBloqueio: true,
        idAtendimentoDjur: state?.djurTarget?.idAtendimentoDjur || 0,
        pageNumber: page,
        pageSize: rowsPerPage,
        nuProcesso: state?.djurTarget?.processoReclamante || '',
        cpfReclamante: state?.djurTarget?.cpfReclamante || FORMAT.unMask(form.getValues('cpfReclamante'))
        // cpfReclamante: FORMAT.unMask(state?.djurTarget?.cpfReclamante || state.form.cpfReclamante),
        // cdContrato: state?.djurTarget?.cdContrato || state?.contract?.cdContrato,
        // ...(state?.form?.dtFimReclamacao && {
        //   competenciaFim: state?.form?.dtFimReclamacao || '',
        // }),
        // ...(state?.form?.dtFimReclamacao && {
        //   competenciaInicio: state?.form?.dtInicioReclamacao || '',
        // })
      })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('Erro ao obter dados do Atendimento Djur')
        }

        if (response?.data?.dadosBloqueio) {

          setPaginatedTable(response?.data?.dadosBloqueio?.items)
          setPageCount(response?.data?.dadosBloqueio?.pageCount)
          setTotal(response?.data?.totalValorBloqueio)
        }
        setLoading('idle')
      })
  }

  useEffect(() => {
    getTableDataWithPagination()
  }, [page, rowsPerPage])

  useEffect(() => {
    const isFirstMount = (state.refreshDadosBloqueio === null) as boolean

    if (!isFirstMount) {
      setPage(1)
      getTableDataWithPagination()
    }
  }, [state.refreshDadosBloqueio])

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>Contrato</TableCellStyled>
              <TableCellStyled>FR/NF</TableCellStyled>
              <TableCellStyled>Valor</TableCellStyled>
              <TableCellStyled>Motivo</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {paginatedTable.length > 0 &&
              paginatedTable?.map((row) => (
                <TableRowStyled key={row.codigoContrato}>
                  <TableCellStyled>{row.codigoContrato}</TableCellStyled>
                  <TableCellStyled>{row.folhaRegistro}</TableCellStyled>
                  <TableCellStyled>
                    {FORMAT.currency(row.valor)}
                  </TableCellStyled>
                  <TableCellStyled>{row.motivoBloqueio}</TableCellStyled>

                </TableRowStyled>
              ))}
            <TableRowStyled backgroundColor={COLORS.lightGray}>
              <TableCellStyled>Total:</TableCellStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled>
                {FORMAT.currency(total)}
              </TableCellStyled>
              <TableCellStyled></TableCellStyled>
            </TableRowStyled>
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        totalItems={pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="online"
      />
    </>
  )
}

export default TableDataLock
